<template>
    <div class='collapsible-panel d-flex flex-column' :class="{ 'is-expanded': !collapsed, 'is-collapsed': collapsed }">
        <div class="collapsible-panel--titlebar d-flex">
            <div class='title-text d-flex flex-grow-1' @click="navigate">
                <slot name="title">
                    <div class="collapsible-panel-headline" :class="smallTitle ? 'collapsible-panel-headline-small-font' : ''">{{ title }}</div>
                </slot>
            </div>
            <div class='title-icon d-flex flex-shrink-1 text-right' @click="collapsed = !collapsed">
                <fe-icon-btn :useIcon="collapsed ? 'fas fa-chevron-left' : 'fas fa-chevron-down'" />
            </div>
        </div>
        <transition name="slide-y-transition">
            <div class="collapsible-panel--body" v-show="!collapsed">
                <slot></slot>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: 'CollapsiblePanel',
        props: {
            title: { type: String },
            value: { type: Boolean, default: false },
            smallTitle: { type: Boolean, default: false },
            navigateOnClick: { type: Boolean, default: false },
        },
        data () {
            return { collapsed: null }
        },
        watch: {
            value: {
                handler(v) { this.collapsed = this.value },
                immediate: true
            },
            collapsed (v) { this.$emit('input', v) }
        },
        methods: {
            navigate() {
                if (!this.navigateOnClick) {
                    this.collapsed = !this.collapsed
                } else {
                    this.$emit('navigationClicked')
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .collapsible-panel {
        width: 100%;
        margin-bottom: 16px;
        &--titlebar {
            width: 100%;
            cursor: pointer;
            .title-icon {
                position: relative;
                top: -10px;
            }
        }
        &--body { margin-bottom: 16px; }
        &-headline {
            font-weight: 400;
            line-height: 2rem;
            letter-spacing: normal!important;
        }
        &-headline-small-font {
            font-size: 18px !important;
        }
    }
</style>